"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var material_ui_image_1 = require("material-ui-image");
var core_1 = require("@material-ui/core");
var financeSectionStyles_1 = require("./financeSectionStyles");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var BackToFinanceButton_1 = require("./button/BackToFinanceButton");
var financeSectionImage = require('../../../common/assets/images/FinanceSectionImage.jpg');
var FinanceSection = function (_a) {
    var startConfigurationSourceUrl = _a.startConfigurationSourceUrl;
    var styles = financeSectionStyles_1.default();
    return (<core_1.Grid container spacing={2} data-test={'checkout:extras:finance_section'} className={styles.financeWrapper}>
      <core_1.Grid item sm={12} md={6}>
        <material_ui_image_1.default src={financeSectionImage} color="transparent" className={styles.image} imageStyle={{ position: 'unset', height: 'auto' }} style={{ paddingTop: 0, position: 'unset' }} animationDuration={0} data-test={'checkout:extras:finance_section:image'}/>
      </core_1.Grid>
      <core_1.Grid item sm={12} md={6} className={styles.financeDetails}>
        <core_1.Typography variant={'h4'} data-test={'checkout:extras:finance_section:title'}>
          <Translation_1.default id={'trans__checkout__extras_page__finance_title'} className={styles.title}/>
        </core_1.Typography>
        <core_1.Typography data-test={'checkout:extras:finance_section:details'}>
          <Translation_1.default id={'trans__checkout__extras_page__finance_description'} className={styles.details}/>
        </core_1.Typography>
        <BackToFinanceButton_1.default startConfigurationSourceUrl={startConfigurationSourceUrl}/>
      </core_1.Grid>
    </core_1.Grid>);
};
exports.default = FinanceSection;
